module.exports = __webpack_public_path__ + "img/Turkey.f360031a.png";